<script setup lang="ts">
import type { StorageNodeWithIndex } from '@d/app/components/file/helper/fileLoader'
import UAsyncFileReader from '@d/app/components/file/UAsyncFileReader.vue'
import ULoading from '@d/app/components/util/ULoading.vue'

const route = useRoute('client-view-path')

const file = ref<StorageNodeWithIndex>()
const path = ref<string[]>(route.params.path)
</script>

<template>
  <Suspense>
    <template #default>
      <UAsyncFileReader
        v-model:file="file"
        v-model:path="path"
        :client="route.params.client"
      />
    </template>
    <template #fallback>
      <ULoading class="view-component" />
    </template>
  </Suspense>
</template>

<style scoped>
.view-component {
  padding: 0px;
  height: 100%
}

.max-full-width {
  max-width: 100% !important;
}

:deep(.v-banner__content) {
  flex-grow: 1;
}

.empty-container{
  border: 1px solid rgb(var(--v-theme-error));
  border-radius: 12px;
  height: fit-content
}

.empty-page{
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center
}
</style>

<i18n lang="yaml">
  de:
    references: Referenzen
    changes: Änderungen
    copy: Kopieren
    move: Verschieben
    rename: Umbenennen
    delete: Löschen
    edit: Bearbeiten
    download: Herunterladen
    create: Erstellen
    fullscreen: Vollbild
    editIndex: Index bearbeiten
    indexHint: Inhalt der index.md
    hideHintPermanent: Die Anzeige kann im Benutzermenü (Rechtsklick) permanent deaktiviert werden
    convert: Umwandeln
    noTags: Keine Tags vorhanden
    error:
      headline: Laden des Elements fehlgeschlagen
      title: Element nicht gefunden
      text: Überprüfe, ob das Element existiert und der zugehörige Storage erreichbar ist
    deleteFinally:
      bin: Papierkorb Leeren
      directory: Endgültig Löschen
      manual: Endgültig Löschen
      file: Endgültig Löschen
    restoreFile: Wiederherstellen
    print: Exportieren
    sharelink: Link Teilen

  en:
    references: References
    changes: Changes
    delete: Delete
    edit: Edit
    download: Download
    create: Create
    copy: Copy
    move: Move
    rename: Rename
    fullscreen: Fullscreen
    editIndex: Edit Index
    indexHint: Content of the index.md
    hideHintPermanent: The display can be permanently deactivated in the user menu (right click)
    convert: Convert
    error:
      headline: Failed to load the element
      title: Element not found
      text: Check whether the element exists and the associated storage is accessible
    deleteFinally:
      bin: Delete Recycle Bin
      directory: Delete finally
      manual: Delete finally
      file: Delete finally
    restoreFile: Restore
    print: Export
    sharelink: Sharelink
  </i18n>
